.assignee-select {
    min-width: 200px;
}
